import type {Viewer} from '../../viewer/Viewer';


/**
 * 重算装配体上下文创建的基准引用。
 *
 * 设计说明：
 * 1. 零部件移动或旋转后，依赖零部件拓扑的基准面、基准轴、基准点都必须重新求解；
 * 2. 统一入口可以避免移动服务、旋转服务和默认拖拽策略分别遗漏某一种基准引用；
 * 3. 当前按“面 -> 点 -> 轴 -> 点”顺序执行，兼顾“轴依赖点”和“点依赖轴”的常见链路。
 *
 * @param viewer 视图实例。
 * @returns 成功重算的基准引用数量。
 */
export function recomputeAssemblyDatumReferences(viewer: Viewer): number {
  const recomputedPlaneCount = viewer.referencePlaneController.recomputeAssemblyDatumPlanes();
  const recomputedPointCountBeforeAxis = viewer.referencePointController.recomputeAssemblyDatumPoints();
  const recomputedAxisCount = viewer.referenceAxisController.recomputeAssemblyDatumAxes();
  const recomputedPointCountAfterAxis = recomputedAxisCount > 0
    ? viewer.referencePointController.recomputeAssemblyDatumPoints()
    : 0;
  const recomputedPointCount = Math.max(recomputedPointCountBeforeAxis, recomputedPointCountAfterAxis);
  // 组件位姿会同时改变模型边、模型面及其派生基准面，统一在全部上游引用稳定后重算镜向关系。
  viewer.reconcileSketchMirrorAxisReferences();
  return recomputedPlaneCount + recomputedAxisCount + recomputedPointCount;
}

